import { render } from "./TarificateurVigeo.vue?vue&type=template&id=6dff4aba&scoped=true"
import script from "./TarificateurVigeo.vue?vue&type=script&lang=js"
export * from "./TarificateurVigeo.vue?vue&type=script&lang=js"

import "./TarificateurVigeo.vue?vue&type=style&index=0&id=6dff4aba&scoped=true&lang=css"

import exportComponent from "/builds/fr.swissLife.nxtCms/cms/nxtcms/nxt-front-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dff4aba"]])

export default __exports__